// Elyra Color Swatches
document.addEventListener('DOMContentLoaded', function() {
  var colorMap = {
    'Μαυρο': '#1A1A18',
    'Μαύρο': '#1A1A18',
    'Μπεζ': '#C8B89A',
    'Μπλε': '#7BB3D4',
    'Ροζ': '#F4A7B9',
    'Μωβ': '#B39CD0'
  };

  function applySwatches() {
    // Find all swatch labels
    document.querySelectorAll('.swatch-input__label').forEach(function(label) {
      var swatch = label.querySelector('.swatch');
      if (!swatch) return;
      
      // Get the value from aria-label or data attribute or text
      var value = label.getAttribute('aria-label') || 
                  label.getAttribute('data-option-value') || 
                  label.textContent.trim();
      
      if (colorMap[value]) {
        swatch.style.setProperty('--swatch--background', colorMap[value]);
        swatch.style.background = colorMap[value];
        label.title = value;
      }
    });
    
    // Also handle variant-selects inputs
    document.querySelectorAll('.product-form__input--swatch').forEach(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;
      
      fieldset.querySelectorAll('input[type="radio"]').forEach(function(input) {
        var value = input.value;
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        
        var swatch = label.querySelector('.swatch');
        if (swatch && colorMap[value]) {
          swatch.style.setProperty('--swatch--background', colorMap[value]);
          swatch.style.background = colorMap[value];
        }
      });
    });
  }
  
  // Run immediately
  applySwatches();
  
  // Run again after a short delay (for dynamic content)
  setTimeout(applySwatches, 500);
  setTimeout(applySwatches, 1500);
  
  // Observe DOM changes
  var observer = new MutationObserver(applySwatches);
  observer.observe(document.body, { childList: true, subtree: true });
});
